import { SELECTED_SEGMENTS } from '../constants';
import { getIntersectionType } from './getLinesIntersection';
import { getPointsDistance } from './distance';
export const getIntersectionScore = (intersectionInteraction, coordinate, editSegment, highlightSegment, intersectionCoord) => {
    if (!intersectionCoord) {
        return 0;
    }
    const { selectedEditSegments, selectedHighlightSegments, supportedHighlightTypes, supportedEditTypes, } = intersectionInteraction;
    const intersectionTypeHighlight = getIntersectionType(highlightSegment, intersectionCoord, selectedHighlightSegments === SELECTED_SEGMENTS.ONE);
    const intersectionTypeEdit = getIntersectionType(editSegment, intersectionCoord, selectedEditSegments === SELECTED_SEGMENTS.ONE);
    const distance = getPointsDistance(coordinate, intersectionCoord);
    return ((supportedHighlightTypes.includes(intersectionTypeHighlight) ? 1 : 0) *
        (supportedEditTypes.includes(intersectionTypeEdit) ? 1 : 0) *
        (1 / distance));
};
//# sourceMappingURL=getIntersectionScore.js.map